import { render, staticRenderFns } from "./WIStepCommentModal.vue?vue&type=template&id=83922d3e&scoped=true"
import script from "./WIStepCommentModal.vue?vue&type=script&lang=js"
export * from "./WIStepCommentModal.vue?vue&type=script&lang=js"
import style0 from "./WIStepCommentModal.vue?vue&type=style&index=0&id=83922d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83922d3e",
  null
  
)

export default component.exports